{
  "badges": {
    "finnairForBusiness": "Work travel benefit"
  },
  "ancillaries": {
    "bundle": {
      "seatMapToggle": {
        "includedSeat": "",
        "showSeatMap": ""
      }
    },
    "seat": {
      "genericTitle": "seat"
    },
    "seatWifi": {
      "genericTitle": "Seat + Internet combo"
    },
    "seatPriority": {
      "genericTitle": "Seat + Priority combo"
    },
    "seatCabinBaggage": {
      "genericTitle": "Seat + Carry-on combo"
    },
    "seatMeal": {
      "genericTitle": "Seat + Meal combo"
    },
    "meal": {
      "genericTitle": "meal"
    },
    "cabinBaggage": {
      "genericTitle": "carry-on bag"
    },
    "wifi": {
      "genericTitle": "internet"
    },
    "priority": {
      "genericTitle": "priority service"
    },
    "lounge": {
      "genericTitle": "lounge access"
    },
    "loungeCabinBaggage": {
      "genericTitle": "Lounge + Carry-on combo"
    },
    "loungePriority": {
      "genericTitle": "Lounge + Priority combo"
    },
    "loungeWifi": {
      "genericTitle": "Lounge + Internet combo"
    },
    "wifiMeal": {
      "genericTitle": "Internet + Meal combo"
    },
    "overlappingServicesNotification": {
      "replaceServiceWithBundle": "Adding this {currentCategory} will remove your current {overlapCategory}.",
      "replaceMultipleServicesWithBundle": "Adding this combo will remove your current selections, which are:",
      "convertServiceToSeatBundle": "This combo adds a seat to your selected {overlapCategory} - with a 10% combo discount.",
      "convertSeatBundleToSeatBundle": "You can add one combo per seat. Switching will replace your {overlapCategory} with {currentCategory}. Your seat stays the same.",
      "convertSeatBundleToSeat": "Adding a seat will remove your currently selected {overlapCategory}.",
      "removeServiceFromBundle": "Adding a different {currentCategory} will remove your selected {overlapCategory}.",
      "removeServiceFromSeatBundle": "Adding a different {currentCategory} will remove the {currentCategory} included in your combo. Your seat stays the same, but will no longer include the 10% combo discount.",
      "keepSeatWithRegularPrice": "Your seat stays the same, but will no longer include the 10% combo discount.",
      "switchToCombo": "Switch to this combo",
      "continueToSelect": "Continue to select {category}",
      "keepSelection": "Keep my selection"
    }
  }
}
